const STORAGE_KEY = "afrimed:favorite-facility-ids:v1";
const EVENT_NAME = "afrimed:facility-favorites:changed";

function normalizeKind(kind = "") {
  const key = String(kind || "").trim().toLowerCase();
  if (key === "hospital" || key === "hospitals") return "hospital";
  if (key === "pharmacy" || key === "pharmacies") return "pharmacy";
  if (key === "ambulance" || key === "ambulances") return "ambulance";
  return "";
}

function readState() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

function writeState(nextState) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(nextState));
  } catch {
    // ignore persistence failures
  }

  try {
    window.dispatchEvent(new Event(EVENT_NAME));
  } catch {
    // ignore event failures
  }
}

export function getFavoriteFacilityIds(kind) {
  const normalizedKind = normalizeKind(kind);
  if (!normalizedKind) return [];

  const state = readState();
  const raw = state?.[normalizedKind];
  return Array.isArray(raw)
    ? raw.map((id) => String(id || "").trim()).filter(Boolean)
    : [];
}

export function isFavoriteFacility(kind, facilityId) {
  const normalizedKind = normalizeKind(kind);
  const id = String(facilityId || "").trim();
  if (!normalizedKind || !id) return false;
  return getFavoriteFacilityIds(normalizedKind).includes(id);
}

export function setFavoriteFacility(kind, facilityId, nextValue) {
  const normalizedKind = normalizeKind(kind);
  const id = String(facilityId || "").trim();
  if (!normalizedKind || !id) return false;

  const state = readState();
  const next = new Set(getFavoriteFacilityIds(normalizedKind));
  if (nextValue) next.add(id);
  else next.delete(id);

  writeState({
    ...state,
    [normalizedKind]: Array.from(next),
  });

  return next.has(id);
}

export function subscribeFacilityFavorites(listener) {
  if (typeof window === "undefined" || typeof listener !== "function") {
    return () => {};
  }
  window.addEventListener(EVENT_NAME, listener);
  return () => window.removeEventListener(EVENT_NAME, listener);
}
